import { Link } from 'react-router-dom'
import { Band, BandStack } from '@/components/ui/Band'
import { ArrowLink } from '@/components/ui/ArrowLink'
import { Eyebrow } from '@/components/ui/Section'
import { useDocumentMeta } from '@/lib/seo'
import { ROUTES } from '@/lib/site'

const SUGGESTIONS = [
  { route: ROUTES.method, detail: 'the eight stages' },
  { route: ROUTES.sections, detail: 'what unlocks each panel' },
  { route: ROUTES.projection, detail: 'the forecast ladder' },
  { route: ROUTES.contact, detail: 'design partners' },
]

export default function NotFound() {
  // A 404 is deliberately excluded from the index; the route is real but has
  // no content worth ranking.
  useDocumentMeta(
    {
      ...ROUTES.home,
      key: 'home',
      path: '/404',
      title: 'Page not found',
      description: 'Nothing is recorded at this address.',
    },
    { noIndex: true },
  )

  return (
    <BandStack>
      <Band tone="ice" showMark={false} routeTab="404">
        <div className="mx-auto max-w-3xl py-8 text-center sm:py-16">
          <img
            src="/brand/bis-mark-128.png"
            srcSet="/brand/bis-mark-128.png 1x, /brand/bis-mark-256.png 2x"
            alt=""
            aria-hidden="true"
            width={128}
            height={155}
            className="anim-float mx-auto mb-8 h-16 w-auto opacity-90"
          />
          <Eyebrow className="text-primary">404</Eyebrow>
          <h1 className="mt-6 text-balance text-[32px] font-extrabold leading-[1.06] tracking-[-0.03em] sm:text-[46px]">
            Nothing is recorded at this address.
          </h1>
          <p className="mx-auto mt-6 max-w-[54ch] text-pretty text-[15px] leading-[1.75] text-muted">
            Which is the same answer a panel gives when it has no source document behind it — so at
            least it is consistent.
          </p>

          <dl className="mx-auto mt-12 grid max-w-xl gap-3 text-left">
            {SUGGESTIONS.map(({ route, detail }) => (
              <div
                key={route.key}
                className="flex flex-wrap items-baseline justify-between gap-3 card-spot rounded-card border border-line bg-white/85 backdrop-blur p-5 shadow-card"
              >
                <dt>
                  <Link
                    to={route.path}
                    className="text-[14.5px] font-bold text-primary underline-offset-4 hover:underline"
                  >
                    {route.footerLabel}
                  </Link>
                </dt>
                <dd className="text-[13px] text-muted">{detail}</dd>
              </div>
            ))}
          </dl>

          <p className="mt-10">
            <ArrowLink to={ROUTES.home.path}>Back to the start</ArrowLink>
          </p>
        </div>
      </Band>
    </BandStack>
  )
}
